module.exports = __webpack_public_path__ + "static/TactileTeam-0cff26aff201fd9dddc4446f6c349b17.mp4";